import { TimelineDataProvider } from "@/features/annotation/hooks/useTimelineData";
import { GondolaChangeGroupsView } from "@/features/gondola-change-groups";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";
import { NavigationItems } from "@/shared/types/navigation";
import { PlayerProvider } from "@/shared/components/PlayerProvider";

export const GondolaChangeGroups = () => {
  useDocumentTitle(NavigationItems.GCG.name);

  return (
    <TimelineDataProvider>
      <PlayerProvider>
        <GondolaChangeGroupsView />
      </PlayerProvider>
    </TimelineDataProvider>
  );
};
